import { Link } from 'react-router-dom';
import logoSrc from 'assets/hvdm-logo-white.png';

const FootCol = ({ label, children }: { label: string; children: React.ReactNode }) => (
  <div className="flex flex-col gap-3">
    <span className="label">{label}</span>
    <div className="text-fg-dim flex flex-col gap-3 text-sm [&_a]:transition-colors [&_a]:duration-[250ms] [&_a:hover]:text-fg">
      {children}
    </div>
  </div>
);

const Footer = () => {
  return (
    <footer className="border-line-faint border-t pt-12 pb-[52px] sm:pt-[60px] sm:pb-16">
      <div className="wrap">
        <div className="flex flex-col gap-[38px] sm:flex-row sm:flex-wrap sm:items-start sm:justify-between sm:gap-12">
          <div className="max-w-none sm:max-w-[22ch]">
            <Link
              to="/"
              className="mb-3.5 flex items-center gap-2.5 text-[15px] font-semibold tracking-[-0.01em] sm:gap-3 sm:text-[17px]">
              <img src={logoSrc} alt="HVDM" className="inline-block h-[17px] w-auto sm:h-[19px]" />
              Harvey de Meester
            </Link>
            <p className="text-fg-dim text-[15px]">
              Independent software studio. Building world-class software solutions for teams,
              startups and founders.
            </p>
          </div>

          <div className="flex w-full flex-wrap gap-x-14 gap-y-10 sm:w-auto sm:gap-11">
            <FootCol label="Elsewhere">
              <a href="https://github.com/hrvdm" target="_blank" rel="noopener noreferrer">
                GitHub
              </a>
              <a
                href="https://www.linkedin.com/in/hrvdm/"
                target="_blank"
                rel="noopener noreferrer">
                LinkedIn
              </a>
            </FootCol>
            <FootCol label="Contact">
              <a href="mailto:hello@hvdm.io">hello@hvdm.io</a>
              <span>London · UK</span>
            </FootCol>
          </div>
        </div>

        <div className="border-line-faint mt-12 flex flex-col items-start gap-2 border-t pt-6 sm:mt-[72px] sm:flex-row sm:flex-wrap sm:items-center sm:justify-between sm:gap-6 sm:pt-7">
          <span className="label">HVDM Ltd</span>
          <span className="label">© 2026 Harvey de Meester</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
